export default function getOption(config, datas) {
  return {
    title: {
      text: config.title,
    },
    xAxis: {
      type: "category",
      data: config.xAxis,
    },
    yAxis: {
      type: "value",
    },
    series: datas.map((data) => {
      let oData = data;
      if (Array.isArray(data)) {
        // 转换为对象
        oData = { data };
      }

      // 参数优先级：data参数 > config参数 > 默认参数
      return { type: config.type, ...config.props, ...oData };
    }),
  };
}
